import { useState } from "react";

export default function CustomCard({ card, onData }) {
  const d = card.data || {};
  const [title, setTitle] = useState(d.title || "");
  const [body, setBody] = useState(d.body || "");
  const [emoji, setEmoji] = useState(d.emoji || "✨");

  const EMOJIS = ["✨", "🚀", "🎯", "💡", "🔥", "🌈", "🎧", "🧠"];

  return (
    <div className="space-y-2">
      <div className="flex items-center gap-2">
        <select data-testid="custom-emoji-select" value={emoji}
          onChange={(e) => { setEmoji(e.target.value); onData({ emoji: e.target.value }); }}
          className="rounded-lg bg-black/10 dark:bg-white/10 px-1 py-1 text-lg outline-none cursor-pointer">
          {EMOJIS.map((e) => <option key={e} value={e}>{e}</option>)}
        </select>
        <input
          data-testid="custom-title-input"
          value={title} onChange={(e) => setTitle(e.target.value)}
          onBlur={() => title !== d.title && onData({ title })}
          placeholder="Give this card a name..."
          className="w-full bg-transparent font-display text-base font-bold outline-none placeholder:opacity-40"
        />
      </div>
      <textarea
        data-testid="custom-body-input"
        value={body} onChange={(e) => setBody(e.target.value)}
        onBlur={() => body !== d.body && onData({ body })}
        placeholder="Anything goes here — links, vibes, goals... ✦" rows={4}
        className="w-full resize-none bg-transparent text-sm leading-relaxed outline-none placeholder:opacity-40"
      />
    </div>
  );
}
